<template>
  <div style="height:100%;background:#fff;border-radius:4px;padding:24px">
    <div>
      <span style="color:rgba(18, 18, 18, 1);font-size:16px;font-weight:bold;">发送记录</span>
      <div style="display:inline-block;float:right">
        <a-dropdown style="margin:0 12px;" :trigger="['click']">
          <a-button type="primary">导出</a-button>
          <a-menu slot="overlay" style="text-align:center">
            <a-menu-item key="1" @click="outputAll">
              <div style="color:rgba(80, 80, 80, 1);font-size:14px;">导出全部</div>
              <div style="color:rgba(188, 188, 188, 1);font-size:12px;">（单次导出上限100000条）</div>
            </a-menu-item>
            <a-menu-divider />
            <a-menu-item key="2" @click="showOutputRecord">
              导出记录
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
    </div>
    <div style="margin-top:20px;">
      <div style="display:inline-block;">
        <div>号码</div>
        <a-input v-model="phoneNum" style="margin-top:8px;width:180px;" placeholder="请输入" />
      </div>
      <div style="display:inline-block;margin:0 60px;">
        <div>发送时间</div>
        <a-range-picker style="margin-top:8px;width:280px;" v-model="timeData" />
      </div>
      <div style="display:inline-block;">
        <div>发送状态</div>
        <a-select default-value="请选择" style="width: 180px;margin-top:8px;margin-right:60px;" v-model="sendState">
          <a-select-option value="">
            请选择
          </a-select-option>
          <a-select-option value="1">
            已发送
          </a-select-option>
          <!-- <a-select-option value="2">
            发送成功
          </a-select-option> -->
          <a-select-option value="3">
            发送失败
          </a-select-option>
        </a-select>
      </div>
      <div style="display:inline-block;">
        <div>短信服务商</div>
        <a-select default-value="请选择" style="width: 180px;margin-top:8px;margin-right:60px;" v-model="msgSupport">
          <a-select-option value="">
            请选择
          </a-select-option>
          <a-select-option :value="item.id" v-for="(item,index) in integratedMsgData" :key='index'>
            {{item.name}}
          </a-select-option>
        </a-select>
      </div>
      <div style="display:inline-block;">
        <div>项目ID</div>
        <a-input v-model="projectId" style="margin-top:8px;width:180px;" placeholder="请输入" />
      </div>
      <div style="float:right;margin-top:10px;margin-top:28px;">
        <span @click="resetCondition" style="display:inline-block;width:64px;height:32px;line-height:32px;text-align:center;cursor:pointer;background:#fff;color:rgba(121, 136, 155, 1);border:1px solid rgba(121, 136, 155, 1);border-radius:4px;font-size:14px;margin-right:12px;">重置</span>
        <span @click="queryBasicData(1)" style="display:inline-block;width:64px;height:32px;line-height:32px;text-align:center;cursor:pointer;background:rgba(121, 136, 155, 0.16);color:rgba(121, 136, 155, 1);border:1px solid rgba(121, 136, 155, 1);border-radius:4px;font-size:14px;">查询</span>
      </div>
    </div>
    <div style="margin-top:24px;">
      <a-table
        :data-source="sendMsgRecord"
        :pagination='false'
        rowKey="id"
        :scroll="{ y: 'calc(100vh - 390px)' }"
      >
        <a-table-column key="id" title="" data-index="id">
          <template slot-scope="text, record, index">
            <div>
              <span>{{index+1}}</span>
            </div>
          </template>
        </a-table-column>
        <a-table-column key="content" title="短信内容" data-index="content" :ellipsis='true'>
          <template slot-scope="text, record">
            <div :title='record.content'>
              {{record.content.length>20?record.content.substring(0,20)+'...':record.content}}
            </div>
          </template>
        </a-table-column>
        <a-table-column key="phone" title="号码" data-index="phone" />
        <a-table-column key="chargeCount" title="计费条数" data-index="chargeCount" />
        <a-table-column key="sendTime" title="发送时间" data-index="sendTime" />
        <a-table-column key="sendStatus" title="发送状态" data-index="sendStatus" />
        <a-table-column key="smsSupplier" title="短信服务商" data-index="smsSupplier" />
        <a-table-column key="smsTemplate" title="操作" data-index="smsTemplate">
          <template slot-scope="text, record">
            <div style="position:relative">
              <div class="view-tpl" style="cursor:pointer">
                <span>查看模板</span>
                <div class="tpl-content" style="position:absolute;width:280px;padding:15px 16px;background:rgba(0, 0, 0, 0.7);color:#fff;font-size:14px;border-radius:4px;left:-280px;top:-20px;cursor:default">{{record.smsTemplate}}</div>
              </div>
            </div>
          </template>
        </a-table-column>
          <!-- <span slot="dataTitle" slot-scope="text, record">
              <a-icon style="color:rgba(121, 136, 155, 0.5);margin-right:6px;float:left;margin-top:4px" @click="viewDetail1(record.id)" type="select" />
              <a @click="viewRecords(record)">{{ record.dataTitle }}</a>
          </span> -->
      </a-table>
      <div class="pagination-table">
          <div class="total-info">
            <span>汇总计费条数：</span>
            <span>{{chargeCountSum}}</span>
          </div>
          <a-pagination
              class="pagination"
              show-size-changer
              :default-current="3"
              :total="total"
              @change="pageChange"
              @showSizeChange="onShowSizeChange"
          />
      </div>
    </div>
    <a-modal :centered='true' :maskClosable='false' v-model.trim="outputWarning" footer='' width='480px'>
      <div class="delete-modal modal-public">
          <div class="sure-off-bind">
              <a-icon type="warning" />
              <span>导出数据已超过最大限度</span>
          </div>
          <div class="tip1">当前条件数据{{total}}条，超过限制</div>
          <div class="tip2">请在查询区域，按时间段查询分次导出</div>
          <a-divider class="divider2" type="horizontal" />
          <div class="btn-group">
              <a-button type="primary" ghost @click="cancelOutput">取消</a-button>
              <a-button type="primary" @click="sureOutput">确定</a-button>
          </div>
      </div>
    </a-modal>
    <a-modal :centered='true' :maskClosable='false' v-model.trim="completeTip" footer='' width='480px'>
      <div class="delete-modal modal-public">
          <div class="sure-off-bind">
              <a-icon style="color:rgba(66, 223, 228, 1)" type="check-circle" />
              <span>导出数据任务已完成</span>
          </div>
          <div class="tip1">共计导出数据：{{exportCount}}条</div>
          <div class="tip2">
            <span>您可前往</span>
            <span @click="viewOutputDetail" style="color:rgba(66, 223, 228, 1);margin:0 4px;cursor:pointer">导出——导出记录</span>
            <span>查看进度详情</span>
          </div>
          <div class="tip2" style="margin-top:10px;">并在任务完成后进行下载</div>
          <a-divider class="divider2" type="horizontal" />
          <div class="btn-group">
              <a-button type="primary" ghost @click="cancelComplete">取消</a-button>
              <a-button type="primary" @click="sureComplete">确定</a-button>
          </div>
      </div>
    </a-modal>
    <a-modal :centered='true' :maskClosable='false' v-model.trim="outputRecordBool" title="导出记录" footer='' width='1120px'>
      <div class="record-modal modal-public">
        <a-divider class="divider1" type="horizontal" />
        <div>
          <span>创建时间：</span>
          <a-range-picker @change="dateChange" />
        </div>
        <a-table rowKey="downloadUrl" style="margin-top:16px;" :data-source="outputData" :pagination='false' :loading="ifShowLoading" :scroll="{ y: 340 }">
          <a-table-column key="createTime" title="创建时间" data-index="createTime" />
          <a-table-column key="exportCount" title="导出数据量" data-index="exportCount" />
          <a-table-column key="status" title="进度" data-index="status">
              <template slot-scope="text, record">
                  <div v-if="record.status==1">
                      <span style="width:8px;height:8px;border-radius:4px;background:rgba(255, 195, 0, 1);display:inline-block;margin-right:8px;"></span>
                      <span>待执行</span>
                  </div>
                  <div v-if="record.status==2">
                      <span style="width:8px;height:8px;border-radius:4px;background:rgba(24, 144, 255, 1);display:inline-block;margin-right:8px;"></span>
                      <span>执行中</span>
                  </div>
                  <div v-if="record.status==3">
                      <span style="width:8px;height:8px;border-radius:4px;background:rgba(67, 207, 124, 1);display:inline-block;margin-right:8px;"></span>
                      <span>已完成</span>
                  </div>
              </template>
          </a-table-column>
          <a-table-column key="downloadUrl" title="附件" data-index="downloadUrl">
              <template slot-scope="text, record">
                  <div v-if="record.downloadUrl!=''">
                      <a :href="record.downloadUrl" style="cursor:pointer;color:#1890FF;">
                          <a-icon style="color:#1890FF;font-size:20px;;" type="download" />
                          下载
                      </a>
                  </div>
              </template>
          </a-table-column>
        </a-table>
        <a-divider class="divider2" type="horizontal" />
        <div class="btn-group">
          <a-button type="primary" ghost @click="cancelRecordBool">取消</a-button>
          <a-button type="primary" @click="sureRecordBool">确定</a-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'SendRecord',
  props: {
    msg: String
  },
   data() {
    return {
      outputWarning: false,
      completeTip: false,
      outputRecordBool: false,
      outputData: [],
      ifShowLoading: false,
      total: 0,
      currentPage: 1,
      pageSize: 10,
      sendState: '',
      msgSupport: '',
      integratedMsgData: [],
      phoneNum: '',
      timeData: null,
      sendMsgRecord: [],
      chargeCountSum: 0,
      exportCount: 0,
      projectId: ''
    }
  },
  methods: {
    moment,
    outputAll() {
      let startTime = '', endTime = ''
      if(this.timeData != null){
        startTime = moment(this.timeData[0], 'YYYY-MM-DD').format('YYYY-MM-DD')
        endTime = moment(this.timeData[1], 'YYYY-MM-DD').format('YYYY-MM-DD')
      }
      this.axios.post('/api/record/export',{
        phone: this.phoneNum,
        minSendTime: startTime,
        maxSendTime: endTime,
        sendStatus: this.sendState,
        smsSupplier: this.msgSupport
      })
      .then(response=> {
        // if(response.data.code == 0){
        //   this.completeTip = true
        // }else{
        //   this.queryExportNum()
        //   this.outputWarning = true
        // }
        if(response.data.code == 0){
          this.queryExportNum()
          this.completeTip = true
        }else if(response.data.code == 'A0002'){
          this.queryExportNum()
          this.outputWarning = true
        }else{
          this.$message.error(response.data.userTip)
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    queryExportNum() {
      let startTime = '', endTime = ''
      if(this.timeData != null){
        startTime = moment(this.timeData[0], 'YYYY-MM-DD').format('YYYY-MM-DD')
        endTime = moment(this.timeData[1], 'YYYY-MM-DD').format('YYYY-MM-DD')
      }
      this.axios.post('/api/record/export/count', {
        phone: this.phoneNum,
        minSendTime: startTime,
        maxSendTime: endTime,
        sendStatus: this.sendState,
        smsSupplier: this.msgSupport,
        projectId: this.projectId
      })
      .then(response=> {
        if(response.data.code == 0){
          this.exportCount = response.data.data.exportCount
        }else{
          this.$message.error(response.data.userTip);
          // if(response.data.code == 'A0200'){
          //   this.$router.push("/Login")
          // }
        }
      })
      .catch(error=> {
        console.log(error);
      });
    },
    cancelOutput() {
      this.outputWarning = false
    },
    sureOutput() {
      this.outputWarning = false
    },
    cancelComplete() {
      this.completeTip = false
    },
    sureComplete() {
      this.completeTip = false
    },
    showOutputRecord() {
      this.outputRecordBool = true
      this.queryOutputData()
    },
    cancelRecordBool() {
      this.outputRecordBool = false
    },
    sureRecordBool() {
      this.outputRecordBool = false
    },
    pageChange(current, pageSize) {
      this.currentPage = current
      this.pageSize = pageSize
      this.queryBasicData(2)
    },
    onShowSizeChange(current, pageSize) {
      this.currentPage = current
      this.pageSize = pageSize
      this.queryBasicData(2)
    },
    queryBasicData(num) {
      let startTime = '', endTime = ''
      if(this.timeData != null){
        startTime = moment(this.timeData[0], 'YYYY-MM-DD').format('YYYY-MM-DD')
        endTime = moment(this.timeData[1], 'YYYY-MM-DD').format('YYYY-MM-DD')
      }
      if(num == 1){
        this.currentPage = 1
      }
      this.axios(
        {
          method:'get',
          url:'/api/record/list', 
          params: {
            current: this.currentPage,
            size: this.pageSize,
            phone: this.phoneNum,
            minSendTime: startTime,
            maxSendTime: endTime,
            sendStatus: this.sendState,
            smsSupplier: this.msgSupport,
            projectId: this.projectId
          }
        }
      )
      .then(response=> {
        if(response.data.code == 0){
          this.sendMsgRecord = response.data.data.records
          this.total = response.data.data.total
        }else{
          this.$message.error(response.data.userTip);
          // if(response.data.code == 'A0200'){
          //   this.$router.push("/Login")
          // }
        }
      })
      .catch(error=> {
          console.log(error)
      })
      if(num == 1){
        this.axios(
          {
            method:'get',
            url:'/api/record/chargeCountSum', 
            params: {
              phone: this.phoneNum,
              minSendTime: startTime,
              maxSendTime: endTime,
              sendStatus: this.sendState,
              smsSupplier: this.msgSupport,
              projectId: this.projectId
            }
          }
        )
        .then(response=> {
          if(response.data.code == 0){
            this.chargeCountSum = response.data.data.chargeCountSum
          }else{
            this.$message.error(response.data.userTip);
            // if(response.data.code == 'A0200'){
            //   this.$router.push("/Login")
            // }
          }
        })
        .catch(error=> {
            console.log(error)
        })
      }
    },
    queryIntegratedMsg() {
      this.axios(
        {
          method:'get',
          url:'/api/supplier/list', 
        }
      )
      .then(response=> {
        if(response.data.code == 0){
          this.integratedMsgData = response.data.data
        }else{
          this.$message.error(response.data.userTip);
          // if(response.data.code == 'A0200'){
          //     this.$router.push("/Login")
          // }
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    resetCondition() {
      this.phoneNum = ''
      this.timeData = null
      this.sendState = ''
      this.msgSupport = ''
      this.projectId = ''
    },
    // viewTpl(id) {
    //   console.log(id)
    // },
    dateChange(date, dateString) {
      this.startTime = dateString[0]
      this.endTime = dateString[1]
      this.queryOutputData()
    },
    queryOutputData() {
      this.axios(
        {
          method:'get',
          url:'/api/record/export/list', 
          params: {
            minCreateTime: this.startTime,
            maxCreateTime: this.endTime,
            projectId: this.projectId
          }
        }
      )
      .then(response=> {
        if(response.data.code == 0){
          this.outputData = response.data.data.records
        }else{
          this.$message.error(response.data.userTip);
          // if(response.data.code == 'A0200'){
          //   this.$router.push("/Login")
          // }
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    viewOutputDetail() {
      this.completeTip = false
      this.outputRecordBool = true
      this.queryOutputData()
    }
  },
  mounted: function() {
    this.sessionData('set','contentNavItem','SceneSms');
    this.queryIntegratedMsg()
    this.queryBasicData(1)
  }
}
</script>

<style scoped lang="less">
  .pagination-table{
    padding-top: 24px;
    .total-info{
      float: left;
      color:rgba(121, 136, 155, 1);
      font-size: 14px;
    }
    .pagination{
      float: right;
    }
  }
  .modal-public{
    .divider1{
        margin: 0px 0 24px 0;
    }
    .divider2{
        margin: 24px 0 12px;
    }
    .btn-group{
      float: right;
      button{
          // width: 64px;
          height: 32px;
          font-size: 14px;
      }
      button:nth-child(1){
          margin-right: 16px;
      }
    }
    .btn-group2{
      float: right;
      button{
          // width: 64px;
          height: 32px;
          font-size: 14px;
      }
      button:nth-child(1){
          background: #fff;
          color: rgba(121, 136, 155, 0.7);
          border: 1px solid rgba(121, 136, 155, 0.5);
          margin-right: 16px;
      }
      button:nth-child(1):hover{
          background: rgba(121, 136, 155, 0.08);
      }
    }
  }
  .delete-modal{
    padding-top: 24px;
    padding-bottom: 44px;
    .sure-off-bind{
        i{
            color: rgba(255, 170, 0, 1);
            font-size: 24px;
        }
        span{
            color: rgba(18, 18, 18, 1);
            font-size: 20px;
            margin-left: 24px;
        }
    }
    .tip1{
        color: rgba(80, 80, 80, 1);
        padding-left: 50px;
        margin: 24px 0 10px 0;
        color: rgba(80, 80, 80, 1);
        font-size: 14px;
    }
    .tip2{
        color: rgba(80, 80, 80, 1);
        padding-left: 50px;
        color: rgba(80, 80, 80, 1);
        font-size: 14px;
    }
  }
  .record-modal{
    padding-bottom: 44px;
    .changed-name{
      color: rgba(153, 153, 153, 1);
      font-size: 14px;
    }
    input{
      margin-top: 8px;
    }
  }
  .view-tpl{
    .tpl-content{
      display: none;
    }
  }
  .view-tpl:hover{
    .tpl-content{
      display: block;
    }
  }
</style>
